import { Select } from '@zambezi/sdk/dropdown-list'
import classNames from 'classnames'
import kebabcase from 'lodash.kebabcase'
import { max, reduce } from 'ramda'
import React from 'react'

import ConsentListSectionHeader from './ConsentListSectionHeader'
import FundsCheckTppCard, { EmptyFundsCheckTppCard } from './FundsCheckTppCard'
import style from './FundsCheckTpps.module.css'
import NavBar from './NavBar'
import PageHeader from './PageHeader'

const NAME = 'Name'
const LAST_CHECKED = 'Last checked'
const LAST_UPDATED = 'Last updated'
const orderOptions = [NAME, LAST_CHECKED, LAST_UPDATED]

export default class FundsCheckTpps extends React.Component {
  constructor(props) {
    super(props)
    this.state = { activeOrdering: orderOptions[0] }
  }

  render() {
    const orderedTpps = tpps =>
      this.props.fundsChecks
        .get(tpps)
        .sortBy(tpp => getComparatorValue(this.state.activeOrdering, tpp))

    return (
      <section className="js-funds-checks">
        <PageHeader
          navbar={<NavBar />}
          title="Funds checks"
          subtitle="These are the service providers you have given permission to ask us if you have sufficient funds in your account(s) for a payment."
        />
        <div className={style.sections}>
          <OrderTppSelector
            onChangeOrder={i => {
              this.setState({ activeOrdering: i })
            }}
          />
          <FundsCheckTppSection
            label="Connected"
            description="Apps and websites who have permission to check your funds."
            tpps={orderedTpps('activeTpps')}
          />

          <FundsCheckTppSection
            label="Disconnected"
            description="History of apps and websites who had permission to check your funds."
            tpps={orderedTpps('inactiveTpps')}
          />
        </div>
      </section>
    )
  }
}

function FundsCheckTppSection({ label, description, tpps }) {
  let i = 0
  return (
    <section
      className={`${style.section} js-${kebabcase(
        label
      )}-funds-check-tpp-section`}
    >
      <ConsentListSectionHeader
        count={tpps.size}
        label={label}
        description={description}
        consentType="fundsCheck"
      />
      {tpps.size > 0 ? (
        tpps
          .map((tpp, index) => (
            <FundsCheckTppCard
              index={i++}
              key={tpp.get('clientId')}
              tpp={tpp}
              className={`js-funds-check-tpp-${index}`}
            />
          ))
          .toArray()
      ) : (
        <EmptyFundsCheckTppCard />
      )}
    </section>
  )
}

function OrderTppSelector({ onChangeOrder }) {
  return (
    <div className={style.selectOrderSection}>
      <div className={classNames(style.selectOrderContainer, 'js-sort-order')}>
        <div className={classNames(style.selectOrderLabel, 'js-sort-label')}>
          Order by:
        </div>
        <Select
          aria-label="TPP selector order by"
          className="js-sort-order-selector"
          defaultValue={orderOptions[0]}
          suggestions={orderOptions}
          onSuggestionSelected={(e, { suggestion }) =>
            onChangeOrder(suggestion)
          }
        />
      </div>
    </div>
  )
}

function getComparatorValue(activeOrdering, tpp) {
  return {
    [NAME]: tpp.get('clientDisplayName'),
    [LAST_CHECKED]: getComparatorValueFromConsents(tpp, consent =>
      consent.getIn(['activity', 'modifiedAt'])
    ),
    [LAST_UPDATED]: getComparatorValueFromConsents(tpp, consent =>
      consent.get('modifiedAt')
    ),
  }[activeOrdering]
}

function getComparatorValueFromConsents(tpp, getConsentUpdateDate) {
  const timestamps = tpp.consents
    .valueSeq()
    .map(getConsentUpdateDate)
    .map(date => (date ? date.getTime() : 0))

  return reduce(max, 0, timestamps) * -1
}
